import { registerEditor } from './registry.js'

import NumericEditor from './NumericEditor.tsx'
import StringEditor from './StringEditor.tsx'
import TimelineEditor from './TimelineEditor.tsx'
import PhotoEditor from './PhotoEditor.tsx'

export const registerAllEditors = () => {
  //console.log("Registering all editors")
  registerEditor(NumericEditor)
  registerEditor(StringEditor)
  registerEditor(TimelineEditor)
  registerEditor(PhotoEditor)
}
